<script lang="ts" setup>
import { computed, onMounted } from "vue";

import WIDGET_ANALYTICS_EVENTS from "~/tiw/helpers/widgetAnalyticsEvents/widgetAnalyticsEvents";
import { useAnalytics } from "~/tiw/hooks/useAnalytics/useAnalytics";
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";
import { useHowYouRateDeviceStore } from "~/tiw/stores/howYouRateDevice/howYouRateDevice";

import { Autopay } from "../../autopay";
import Modal from "../../modal/modal.vue";

onMounted(() => {
    useAnalytics(WIDGET_ANALYTICS_EVENTS.CREDIT_CARD_DATA);
});

const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const devicePrice = computed(() => {
    if (typeof HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale === "object") {
        return HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale?.tradeInSale;
    }

    return HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale;
});
</script>

<template>
    <Modal class="tiw__step__creditCartPreAuthorization__payment">
        <template #header>
            <p class="tiw__h2">
                {{ useTranslate("tiw__creditCardPreAuthorization__title") }}
            </p>
            <div class="tiw__step__creditCardPreAuthorization__payment__amount">
                <p>{{ useTranslate("tiw__transaction__amount") }}</p>
                <p>{{ devicePrice }} {{ HowYouRateDeviceStore.registeringDeviceData.currency }}</p>
            </div>
        </template>
        <div class="tiw__step__creditCardPreAuthorization__payment__body">
            <Autopay />
        </div>
    </Modal>
</template>

<style lang="scss" src="./creditCartPreAuthorization.scss"></style>
